<!--
	Tile.svelte
-->

<script>
    import { push } from "svelte-spa-router";
    import { clearMasterSearch } from '../../common/master-objects.js';

    export let route;
    export let label;

    const onClick = () => {
        if (route === '') return;
        // if (route === '/explorer') clearMasterSearch();        // cheating! not generic!
        push(route);
    }

</script>

<style>
    .tile {
        position: relative;
        /* width: 33%; */
        width: 22%;
        padding: 0px;
        margin: 10px;
        opacity: .8;
        /* font-size: 2em; */
        font-size: 1em;
        background-color: var(--tcare-white);
        border-radius: 20px;
        overflow: hidden;
        user-select: none;
        box-shadow: 1px 1px 1px var(--tcare-gray);
        transition: all .2s;
    }

    .tile:hover {
        background-color: var(--tcare-secondary);
        transform: scale(1.05);
    }

    .tile-icon {
        width: 100%;
        height: 150px;
        text-align: center;
        top: 10px;
        /* border: 1px solid red; */
    }

    :global(.tile-icon svg) {
        width: 50%;
        height: 80%;
        outline: none;
        fill: var(--tcare-primary);
        /* border: 1px solid red; */
    }

    /*
    :global(.tile-icon svg):hover {
        fill: var(--tcare-secondary);
    }
    */
    
    .tile-label {
        position: relative;
        width: 100%;
        font-size: 1em;
        font-weight: 100;
        text-align: center;
        bottom: 10px;
        /* border: 1px solid green; */
    }

    @media screen and (max-width: 600px) {
        .tile {
            /* width: 45%; */
            height: 130px;
            margin: 0px;
            margin-bottom: 10px;
        }
        .tile-label {
            font-size: .5em;
        }
        .tile-icon {
            height: 110px;
        }
    }

    @media screen and (min-width: 601px) and (max-width: 800px) {
        .tile {
            /* width: 45%; */
        }
    }

    @media screen and (min-width: 801px) and (max-width: 1300px) {
        .tile {
            /* width: 30%; */
        }
    }

    @media screen and (min-width: 1201px) {
        .tile {
            /* width: 30%; */
        }
    }

</style>

<div class="tile" on:click={onClick}>
    <div class="tile-icon flex-center">
        <slot></slot>
    </div>
    <div class="tile-label">{label}</div>
</div>
